/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit

* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.

* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/

export const dir = {
	ltr: 'ltr',
	trl: 'rtl',
};

export const messageType = {
	error: 'error',
	warning: 'warning',
	informational: 'informational',
};

export const textAlign = {
	left: 'left',
	right: 'right',
	center: 'center',
};

export const textDir = {
	blank: '',
	ltr: 'ltr',
	rtl: 'rtl',
	auto: 'auto',
};

export const type = {
	number: 'number',
	text: 'text',
	password: 'password',
	time: 'time',
};
